import { render, staticRenderFns } from "./Cuves.vue?vue&type=template&id=2d47e227&"
import script from "./Cuves.vue?vue&type=script&lang=js&"
export * from "./Cuves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports